import { render, staticRenderFns } from "./Interpreter.vue?vue&type=template&id=37a707d4&scoped=true&"
import script from "./Interpreter.vue?vue&type=script&lang=js&"
export * from "./Interpreter.vue?vue&type=script&lang=js&"
import style0 from "./Interpreter.vue?vue&type=style&index=0&id=37a707d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a707d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a707d4')) {
      api.createRecord('37a707d4', component.options)
    } else {
      api.reload('37a707d4', component.options)
    }
    module.hot.accept("./Interpreter.vue?vue&type=template&id=37a707d4&scoped=true&", function () {
      api.rerender('37a707d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Interpreting/Interpreter.vue"
export default component.exports